export default __webpack_public_path__ + "static-bigflip/media/deed-of-latest-board.d53e7968.png";